import { Box } from "@mui/material";
import RogoLogo from "../../../../assets/images/icon.svg";

export const LoadingComponent = () => {
	return (
		// load assets/images/icon.svg and make it spin
		<Box
			component="img"
			id="rogoloader"
			src={RogoLogo}
			alt="Rogo Logo"
			// React 19 recognises camelCase `fetchPriority` as a first-class DOM prop.
			// The lowercase spread this replaces was a React 18 workaround that the
			// upgrade inverted: React 19 rejects `fetchpriority` with "Invalid DOM
			// property", so the workaround had become the noise it was avoiding.
			fetchPriority="high"
			// 200x200 in sx: on a Box, width/height props are read as CSS rather than img attributes.
			sx={{ width: 200, height: 200, animation: "spin 2s linear infinite" }}
		/>
	);
};
